import { updateNotification } from '../../graphql/mutations';
import isInGroup from '../../services/util/isInGroup';
import {
  OPENED_NOTIFICATION_REQUESTED,
  OPENED_NOTIFICATION_COMPLETED,
  OPENED_NOTIFICATION_FAILED,
  OPENED_NOTIFCATIONS_ABORTED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

function handleLinkUrl(url, navigate) {
  // Check if URL contains a protocol (full URL)
  if (url.includes('://')) {
    try {
      const { host, pathname } = new URL(url);

      // Check if host (includes port) matches VITE_APP_DOMAIN
      if (host === import.meta.env.VITE_APP_DOMAIN) {
        navigate(pathname);

        return;
      }
    } catch (e) {
      // Invalid URL, fall through to external URL handling
    }

    // External URL, use window.location.href
    window.location.href = url;

    return;
  }

  // URL is a path (with or without leading slash)
  const path = url.startsWith('/') ? url : `/${url}`;

  navigate(path);
}

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const markAsOpenedAction =
  (notification, navigate) => async (dispatch, getState) => {
    dispatch({
      type: OPENED_NOTIFICATION_REQUESTED,
    });

    try {
      const { notifications, session } = getState();

      const sessionData = session.get('data');

      if (!isInGroup(sessionData, 'Client')) {
        const { LinkUrl, LinkRedirectCommand, LinkActionApprovalDocID } =
          notification;

        if (LinkUrl) {
          handleLinkUrl(LinkUrl, navigate);
        } else if (LinkRedirectCommand) {
          navigate('/actions', {
            state: {
              Command: LinkRedirectCommand,
            },
          });
        } else if (LinkActionApprovalDocID) {
          navigate('/actions', {
            state: {
              ActionApprovalDocID: LinkActionApprovalDocID,
            },
          });
        }

        dispatch({
          type: OPENED_NOTIFCATIONS_ABORTED,
        });

        return;
      }

      const { data } = await api.graphql({
        query: updateNotification,
        variables: {
          input: {
            id: notification.id,
            IsClicked: true,
            IsRead: true,
          },
        },
      });
      const updatedItem = data.updateNotification;

      const notificationsData = notifications.get('data');
      const { items } = notificationsData;

      const foundIndex = items.findIndex(
        (element) => element.id === notification.id,
      );
      items[foundIndex] = updatedItem;
      const { LinkUrl, LinkRedirectCommand, LinkActionApprovalDocID } =
        updatedItem;
      if (LinkUrl) {
        window.location.href = LinkUrl;
      } else if (LinkRedirectCommand) {
        navigate('/actions', {
          state: {
            Command: LinkRedirectCommand,
          },
        });
      } else if (LinkActionApprovalDocID) {
        navigate('/actions', {
          state: {
            ActionApprovalDocID: LinkActionApprovalDocID,
          },
        });
      }

      dispatch({
        type: OPENED_NOTIFICATION_COMPLETED,
        payload: items,
      });
    } catch (err) {
      debug(OPENED_NOTIFICATION_FAILED, err);

      dispatch({
        type: OPENED_NOTIFICATION_FAILED,
        payload: err,
      });
    }
  };

export default markAsOpenedAction;
